
import { Options, Vue } from 'vue-class-component';
import FieldDatePicker from '@/components/fields/FieldDatePicker.vue';
import FieldTotalSelector from '@/components/fields/FieldTotalSelector.vue';
import Button from '@/components/atoms/Button.vue';
import { addDays } from '@/dates';

@Options({
    components: {
        FieldDatePicker,
        FieldTotalSelector,
        Button,
    },
    props: {
    },
})

export default class SearchBar extends Vue {

    dates: any = {
        start: new Date(),
        end: addDays(new Date(), 6),
    };
    guests: any = {
        adults: 2,
        children: 0,
    };

    mounted() {
        const params = new URLSearchParams(window.location.search);
        let dateFrom, dateTo, adults, children;

        if (
            (dateFrom = params.get('dateFrom'))
            && (dateTo = params.get('dateTo'))
        ) {
            this.dates.start = new Date(dateFrom);
            this.dates.end = new Date(dateTo);
        }

        if (
            (adults = params.get('adults'))
            && (children = params.get('children'))
        ) {
            this.guests = {
                adults: parseInt(adults),
                children: parseInt(children),
            }
        }
    }
}
